module.exports = __webpack_public_path__ + "img/compass.4883b2ea.svg";